

<div class="wrapper">
  <div class="content-wrapper">
    <div class="br-section-wrapper">
      <div class="form-group formWrapper">
        <div class="row searchWrapper">
          <div class="form-row">

            <div class="col-12 text-center" style="margin-bottom: 16px;">
              <button class="btn btn-submit toggle-btn small-btn" (click)="toggleRoutes()">
                Select Routes
                <span [class.rotate]="selectRoutes">▼</span>
              </button>
            </div>
            <div class="col-12 collapsible" [@slideToggle]="selectRoutes ? 'open' : 'closed'">
              <app-driver-route-sheet *ngIf="selectRoutes" (selectRoute)="selectRoute($event)" [fromBolPage]="true"></app-driver-route-sheet>
            </div>

            <div class="col-6 col-md-3">
              <input type="text" id="scac" class="form-control height-25" [(ngModel)]="bolFilter.scac" style="padding: 10px;" (blur)="validateScac()"
                (ngModelChange)="onInputChange('scac')" placeholder="SCAC" required />
                <div *ngIf="isScacInvalid" 
                   style="color: red; font-size: 12px; margin-top: 3px;">
                SCAC is mandatory.
              </div>
            </div>
            
            <div class="col-6 col-md-3">
              <input type="text" id="bolId" class="form-control height-25" [(ngModel)]="bolFilter.bolId" style="padding: 10px;"
                (ngModelChange)="onInputChange('bolId')" placeholder="BOL ID" />
            </div>
      
            <div class="col-6 col-md-3">
              <input type="text" id="routeId" class="form-control height-25" [(ngModel)]="bolFilter.routeId" style="padding: 10px;"
                (ngModelChange)="onInputChange('routeId')" placeholder="Route ID" />
            </div>
      
            <div class="col-6 col-md-3">
              <input type="text" id="driverId" class="form-control height-25" [(ngModel)]="bolFilter.driverId" style="padding: 10px;"
                (ngModelChange)="onInputChange('driverId')" placeholder="Driver ID" />
            </div>
      
            <div class="col-6 col-md-3">
              <input type="text" id="logon" class="form-control height-25" [(ngModel)]="bolFilter.logon" style="padding: 10px;"
                (ngModelChange)="onInputChange('logon')" placeholder="Logon" />
            </div>
      
            <div class="col-6 col-md-3">
              <input type="text" id="fname" class="form-control height-25" [(ngModel)]="bolFilter.fname" style="padding: 10px;"
                (ngModelChange)="onInputChange('fname')" placeholder="First Name" />
            </div>
      
            <div class="col-6 col-md-3">
              <input type="text" id="lname" class="form-control height-25" [(ngModel)]="bolFilter.lname" style="padding: 10px;"
                (ngModelChange)="onInputChange('lname')" placeholder="Last Name" />
            </div>
      
            <div class="col-6 col-md-3">
              <input id="datePicker" class="form-control height-25" ngbDatepicker #d="ngbDatepicker" style="padding: 10px;"
                [(ngModel)]="bolFilter.selectedDate" placeholder="yyyy-mm-dd"
                (click)="isDatePickerDisabled ? null : d.toggle()" [disabled]="isDatePickerDisabled" />
            </div>
      
            <div class="col-12 text-center mt-4">
              <button class="btn btn-submit" (click)="submitMethod()">Submit</button>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="padding: 20px; margin-top: 30px;" *ngIf="!users || users.length == 0">
        <div class="col-12">
          <i style="font-size: 12px;">** NOTE: Please input scac, (bolid) / (routeid) / (driverid and date) and hit
            submit button to view route and bill of lading information !</i>
        </div>
      </div>

      <div class="table-responsive" style="padding: 10px;">
        <h4>Route Information</h4>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Route ID</th>
              <th>Route Status</th>
              <th>Date</th>
              <th>Driver</th>
              <th>Device</th>
              <th>Scac</th>
              <th>Punch In</th>
              <th>Punch Out</th>
              <th>Tstamp</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ users?.driverRouteSheetDTO?.routeId }}</td>
              <td>{{ users?.driverRouteSheetDTO?.routeStatus }}</td>
              <td>{{ users?.driverRouteSheetDTO?.date }}</td>
              <td><a href="javascript:void(0)" data-toggle="modal" data-target="#driverModal"
                  (click)="redirectToDriverScreen(users)">{{ users?.driverRouteSheetDTO?.driverId }} : {{
                  users?.driverDTO?.fname }} {{ users?.driverDTO?.lname }}</a></td>
              <td>
                <div class="d-flex flex-wrap">
                  <div *ngFor="let device of users?.deviceDTOs" class="device-card pointer m-2"
                    style="cursor: pointer; width: 50px; height: 50px; background-color: #f0f8ff; font-size: 9px;"
                    (click)="openDeviceModal(device)">
                    <div class="card-body">
                      <a href="javascript:void(0)" data-toggle="modal"
                        data-target="#deviceModal">{{device?.deviceUser}}</a>
                    </div>
                  </div>
                </div>
              </td>
              <td>{{ users?.scac }}</td>
              <td>{{ users?.driverRouteSheetDTO?.startTime || 'N/A' }}</td>
              <td>{{ users?.driverRouteSheetDTO?.punchOut || 'N/A' }}</td>
              <td>{{ users?.driverRouteSheetDTO?.tStamp || 'N/A' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-responsive" style="padding: 10px;">
        <h5>Bill of Lading (BOL)</h5>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th></th>
              <th>BOL ID</th>
              <th>Trip No</th>
              <th>Dealer</th>
              <th>Bill Type</th>
              <th>Schedule Date</th>
              <th>Truck ID</th>
              <th>BOL Status</th>
              <th>Multiple Suppliers</th>
              <th>At Rack</th>
              <th>Left Rack</th>
              <th>At Location</th>
              <th>Left Location</th>
              <th>Tstamp</th>
            </tr>
          </thead>
          <tbody *ngIf="billofladingDTOs?.length > 0">
            <ng-container *ngFor="let bol of billofladingDTOs">
              <tr>
                <td>
                  <button class="btn btn-sm btn-primary" (click)="bol.showDetails = !bol.showDetails">
                    {{ bol.showDetails ? '-' : '+' }}
                  </button>
                </td>
                <td>{{ bol?.billOfLadingId }}</td>
                <td>{{ bol?.tripNo }}</td>
                <td><a href="javascript:void(0)" data-toggle="modal" data-target="#dealerModal"
                    (click)="openDealerModal(bol?.dealer)">{{ bol?.dealer?.dealer || 'N/A' }}</a></td>
                <td><a href="javascript:void(0)" data-toggle="modal" data-target="#billtypeModal"
                    (click)="openBillTypeModal(bol?.dealer?.billtype)">{{ bol?.dealer?.billtype?.billingCodeName ||
                    'N/A' }}</a></td>
                <td>{{ bol?.scheduleDate }}</td>
                <td>{{ bol?.truck }}</td>
                <td>{{ bol?.bolstatus }} - {{ chooseStatus(bol?.bolstatus) }}</td>
                <td>{{ bol?.multipleSuppliers ? 'Yes' : 'No' }}</td>
                <td>{{ bol?.arrivedAtRackTime || 'N/A' }}</td>
                <td>{{ bol?.leftRackTime || 'N/A' }}</td>
                <td>{{ bol?.arrivedAtCustomerTime || 'N/A' }}</td>
                <td>{{ bol?.finalizedDeliveryTime || 'N/A' }}</td>
                <td>{{ bol?.tStamp || 'N/A'}}</td>
              </tr>
              <tr *ngIf="bol.showDetails">
                <td colspan="12">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th class="background-color-change">Detail ID</th>
                        <th class="background-color-change">Terminal</th>
                        <th class="background-color-change">Quantity</th>
                        <th class="background-color-change">Ordered Quantity</th>
                        <th class="background-color-change">Net Gallons</th>
                        <th class="background-color-change">Product</th>
                        <th class="background-color-change">Driver Confirmed</th>
                        <th class="background-color-change">End Load Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let detail of bol.billofladingdetails">
                        <td>{{ detail?.detailID }}</td>
                        <td>{{ detail?.terminal }}</td>
                        <td>{{ detail?.quantity }}</td>
                        <td>{{ detail?.ordered }}</td>
                        <td>{{ detail?.netGallons }}</td>
                        <td><a href="javascript:void(0)" data-toggle="modal" data-target="#productModal"
                            (click)="openProductModal(detail?.product)">{{ detail?.product?.productId }} : {{
                            detail?.product?.productName }}</a></td>
                        <td>{{ detail?.driverconfirmed ? 'Yes' : 'No' }}</td>
                        <td>{{ detail?.boldetailsEndLoadTime }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>


<div class="modal fade" id="driverModal" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Driver Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-striped">
          <tbody>
            <tr>
              <td><strong>Driver Name</strong></td>
              <td>{{ selectedRecord?.fname }} {{ selectedRecord?.lname }}</td>
            </tr>
            <tr>
              <td><strong>User ID</strong></td>
              <td>{{ selectedRecord?.userID }}</td>
            </tr>
            <tr>
              <td><strong>Password</strong></td>
              <td>{{ selectedRecord?.mobilepassword }}</td>
            </tr>
            <tr>
              <td><strong>Update Source</strong></td>
              <td>{{ selectedRecord?.updatesource }}</td>
            </tr>
            <tr>
              <td><strong>Timestamp</strong></td>
              <td>{{ selectedRecord?.tstamp }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="bolModal" class="modal fade" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content bol-modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Bill of Lading Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-bordered table-insurance-inner">
          <thead class="thead-dark">
            <tr>
              <th class="wd-15p th-pd">BOL ID</th>
              <th class="wd-15p th-pd">Trip No</th>
              <th class="wd-15p th-pd">Dealer</th>
              <th class="wd-15p th-pd">Schedule Date</th>
              <th class="wd-15p th-pd">Truck ID</th>
              <th class="wd-15p th-pd">BOL Status</th>
              <th class="wd-15p th-pd">Multiple Suppliers</th>
              <th class="wd-15p th-pd">At Rack</th>
              <th class="wd-15p th-pd">Left Rack</th>
              <th class="wd-15p th-pd">At Location</th>
              <th class="wd-15p th-pd">Left Location</th>
              <th class="wd-15p th-pd">View Details</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let bol of billOfLadingList">
              <tr>
                <td>{{ bol.billOfLadingId }}</td>
                <td>{{ bol.tripNo }}</td>
                <td>{{ bol.dealer || 'N/A' }}</td>
                <td>{{ bol.scheduleDate }}</td>
                <td>{{ bol.truck }}</td>
                <td>{{ bol.bolstatus }}</td>
                <td>{{ bol.multipleSuppliers ? 'Yes' : 'No' }}</td>
                <td>{{ bol.arrivedAtRackTime || 'N/A' }}</td>
                <td>{{ bol.leftRackTime || 'N/A' }}</td>
                <td>{{ bol.arrivedAtCustomerTime || 'N/A' }}</td>
                <td>{{ bol.finalizedDeliveryTime || 'N/A' }}</td>
                <td>
                  <button class="btn btn-sm btn-primary" (click)="bol.showDetails = !bol.showDetails">
                    {{ bol.showDetails ? '-' : '+' }}
                  </button>
                </td>
              </tr>

              <tr *ngIf="bol.showDetails">
                <td colspan="12">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th class="black-font">Detail ID</th>
                        <th class="black-font">Terminal</th>
                        <th class="black-font">Quantity</th>
                        <th class="black-font">Ordered Quantity</th>
                        <th class="black-font">Net Gallons</th>
                        <th class="black-font">Product ID</th>
                        <th class="black-font">Driver Confirmed</th>
                        <th class="black-font">End Load Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let detail of bol.billofladingdetails">
                        <td>{{ detail.detailID }}</td>
                        <td>{{ detail.terminal }}</td>
                        <td>{{ detail.quantity }}</td>
                        <td>{{ detail.ordered }}</td>
                        <td>{{ detail.netGallons }}</td>
                        <td>{{ detail.productId }}</td>
                        <td>{{ detail.driverconfirmed }}</td>
                        <td>{{ detail.boldetailsEndLoadTime }}</td>
                      </tr>
                    </tbody>

                  </table>
                  <div *ngIf="bol.billofladingdetails?.length == 0">
              <tr class="text-center">No bill of lading details available!</tr>
      </div>
      </td>
      </tr>
      </ng-container>
      </tbody>
      </table>
      <div *ngIf="billOfLadingList?.length == 0">
        <tr class="text-center">No bill of lading available!</tr>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
    </div>
  </div>
</div>
</div>


<div class="modal fade" id="deviceModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Device Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-striped">
          <tbody>
            <tr>
              <td>Device ID</td>
              <td>{{ selectedDevice?.deviceId }}</td>
            </tr>
            <tr>
              <td>Device Name</td>
              <td>{{ selectedDevice?.deviceName }}</td>
            </tr>
            <tr>
              <td>Device Code</td>
              <td>{{ selectedDevice?.deviceCode }}</td>
            </tr>
            <tr>
              <td>Is Active</td>
              <td>{{ selectedDevice?.isActive }}</td>
            </tr>
            <tr>
              <td>Last Activity</td>
              <td>{{ selectedDevice?.lastActivity }}</td>
            </tr>
            <tr>
              <td>Mobile App Version</td>
              <td>{{ selectedDevice?.mobileAppVersion }}</td>
            </tr>
            <tr>
              <td>Device User</td>
              <td>{{ selectedDevice?.deviceUser }}</td>
            </tr>
            <tr>
              <td>Created Date</td>
              <td>{{ selectedDevice?.createdDate }}</td>
            </tr>
            <tr>
              <td>Updated By</td>
              <td>{{ selectedDevice?.updatedBy }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="dealerModal" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Dealer Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-striped">
          <tbody>
            <tr>
              <td><strong>Dealer Name</strong></td>
              <td>{{ selectedDealer?.dealer }}</td>
            </tr>
            <tr>
              <td><strong>Dealer Address</strong></td>
              <td>{{ selectedDealer?.address }}, {{ selectedDealer?.city }}, {{ selectedDealer?.state }}</td>
            </tr>
            <tr>
              <td><strong>Dealer Location</strong></td>
              <td>Lat: {{ selectedDealer?.latitude }}, Long: {{ selectedDealer?.longitude }}, Radius: {{
                selectedDealer?.radius }}</td>
            </tr>
            <tr>
              <td><strong>Dealer Location Id</strong></td>
              <td>{{ selectedDealer?.locationID }}</td>
            </tr>
            <tr>
              <td><strong>Dealer Special Instruction</strong></td>
              <td>{{ selectedDealer?.specialInstructions }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="billtypeModal" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">BillType Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-striped">
          <tbody>
            <tr>
              <td><strong>Billtype Code Name</strong></td>
              <td>{{ selectedBillType?.billingCodeName }}</td>
            </tr>
            <tr>
              <td><strong>Billtype Display Name</strong></td>
              <td>{{ selectedBillType?.displayName }}</td>
            </tr>
            <tr>
              <td><strong>Billing CSZ</strong></td>
              <td>{{ selectedBillType?.billingCSZ }}</td>
            </tr>
            <tr>
              <td><strong>Billing Address</strong></td>
              <td>{{ selectedBillType?.billingAddress }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="productModal" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Product Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-striped">
          <tbody>
            <tr>
              <td><strong>Product Name</strong></td>
              <td>{{ selectedProduct?.productName }}</td>
            </tr>
            <tr>
              <td><strong>Product ID</strong></td>
              <td>{{ selectedProduct?.productId }}</td>
            </tr>
            <tr>
              <td><strong>Display Code</strong></td>
              <td>{{ selectedProduct?.displayCode }}</td>
            </tr>
            <tr>
              <td><strong>Product Description</strong></td>
              <td>{{ selectedProduct?.productDescription }}</td>
            </tr>
            <tr>
              <td><strong>Octane</strong></td>
              <td>{{ selectedProduct?.octane }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>